<header class="header">
  <div class="arrow-button" onclick="history.back()"></div>
  <h1>
    <img
      class="logo-image"
      src="/assets/sas-management/images/logo.svg"
      width="194"
      height="20"
      alt="SasManagement"
    />
  </h1>
</header>
<div class="container">
  <div data-app="true" class="v-application v-application--is-ltr theme--light main-contents">
    <div class="v-application--wrap">
      <div class="inner">
        <div class="auto-layout mb-2">
          <h1 class="login-title">新規会員登録</h1>
          <app-sas-management-oem-register-message
            [clientId]="clientId"
            *ngIf="isOem; else isStation"
          ></app-sas-management-oem-register-message>
          <ng-template #isStation>
            <p class="v-text">
              ご登録完了後、ご入力いただいたメールアドレス宛に登録の確認メールをお送りします。
            </p>
          </ng-template>
        </div>
        <div class="name-area">
          <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
          <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
          <div
            class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          >
            <div class="v-input__control">
              <div
                class="v-input__slot"
                [ngClass]="
                  errorMessages.signup.familyName ? ['custom-error'] : []
                "
              >
                <div class="v-text-field__slot v-text-body-1">
                  <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                  <label for="lastName" [class]="familyNameLabelClass"
                    >姓</label
                  >
                  <input
                    (focus)="focus(inputState.lastName)"
                    (blur)="blur(inputState.lastName)"
                    [(ngModel)]="lastName"
                    id="lastName"
                    type="text"
                  />
                </div>
              </div>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.signup.familyName"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.signup.familyName }}
                    <!-- 注釈及びエラーテキストが入ります。 -->
                    <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
          <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
          <div
            class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          >
            <div class="v-input__control">
              <div
                class="v-input__slot"
                [ngClass]="
                  errorMessages.signup.givenName ? ['custom-error'] : []
                "
              >
                <div class="v-text-field__slot v-text-body-1">
                  <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                  <label for="firstName" [class]="givennameLabelClass"
                    >名</label
                  >
                  <input
                    (focus)="focus(inputState.firstName)"
                    (blur)="blur(inputState.firstName)"
                    [(ngModel)]="firstName"
                    id="firstName"
                    type="text"
                  />
                </div>
              </div>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->

                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.signup.givenName"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.signup.givenName }}
                    <!-- 注釈及びエラーテキストが入ります。 -->
                    <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="isOem"
          style="margin-top: -20px; margin-bottom: 20px; padding: 0 12px"
        >
          <p class="v-text-caption" *ngIf="oemId === 'new-osaka'; else default">
            自宅療養者ご本人の姓名を入力してください
          </p>
          <ng-template #default>
            <p class="v-text-caption">陽性者本人の姓名を入力してください</p>
          </ng-template>
        </div>

        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="errorMessages.signup.email ? ['custom-error'] : []"
            >
              <div class="v-text-field__slot">
                <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                <label
                  for="email"
                  [ngClass]="inputLabelClass"
                  class="text-black-38"
                  >メールアドレス</label
                >
                <input
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  [(ngModel)]="email"
                  id="email"
                  type="email"
                />
              </div>
            </div>
            <div class="v-text-field__details">
              <p class="v-text-caption" *ngIf="oemId === 'new-osaka'">
                PCメールアドレスを入力してください<br />
                ※キャリアメールの場合メールが届かないことがあります。予め「＠dx-utility.com」からの受信を許可してください
              </p>
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.signup.email"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.signup.email }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
        <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="errorMessages.signup.password ? ['custom-error'] : []"
            >
              <div class="v-text-field__slot">
                <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                <label
                  for="password"
                  [ngClass]="passwordLabelClass"
                  class="text-black-38"
                  >パスワード</label
                >
                <input
                  (focus)="focus(inputState.password)"
                  (blur)="blur(inputState.password)"
                  [(ngModel)]="password"
                  id="password"
                  [type]="passwordToggle.password ? 'text' : 'password'"
                />
              </div>
              <div class="v-input__append-inner">
                <div class="v-input__icon v-input__icon--append">
                  <app-mdi-eye
                    [show]="passwordToggle.password"
                    (click)="passwordToggle.password = !passwordToggle.password"
                  ></app-mdi-eye>
                </div>
              </div>
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.signup.password"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.signup.password }}
                </div>
                <div *ngIf="!errorMessages.signup.password">
                  <p class="v-text-caption">
                    半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
        <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
        <div
          class="mb-6 v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="
                errorMessages.signup.confirmPassword ? ['custom-error'] : []
              "
            >
              <div class="v-text-field__slot">
                <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                <label
                  for="confirmationPassword"
                  [ngClass]="confirmPasswordLabelClass"
                  class="text-black-38"
                  >パスワード（確認）</label
                >
                <input
                  (focus)="focus(inputState.confirmPassword)"
                  (blur)="blur(inputState.confirmPassword)"
                  id="confirmationPassword"
                  [type]="passwordToggle.confirm ? 'text' : 'password'"
                  [(ngModel)]="confirmPassword"
                />
              </div>
              <div class="v-input__append-inner">
                <div class="v-input__icon v-input__icon--append">
                  <app-mdi-eye
                    [show]="passwordToggle.confirm"
                    (click)="passwordToggle.confirm = !passwordToggle.confirm"
                  ></app-mdi-eye>
                </div>
              </div>
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.signup.confirmPassword"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.signup.confirmPassword }}
                </div>
                <div *ngIf="!errorMessages.signup.confirmPassword">
                  <p class="v-text-caption">
                    パスワードを確認するために再入力してください
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <label class="agreement d-flex align-start mb-6"
          ><div
            class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox mb-8"
            (click)="check()"
          >
            <div class="v-input__control">
              <div>
                <div class="v-input--selection-controls__input primary--text">
                  <i
                    aria-hidden="true"
                    [class]="checkedStyle.i"
                    class="text-black-38"
                  ></i
                  ><input
                    aria-checked="true"
                    id="input-32"
                    role="checkbox"
                    type="checkbox"
                    value=""
                  />
                  <div [class]="checkedStyle.div"></div>
                </div>
              </div>
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.signup.terms"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.signup.terms }}
                </div>
              </div>
            </div>
          </div>
          <span class="checkbox-text">
            <a
              [href]="termsUrl"
              target="_blank"
              class="text-link primary--text"
              >利用規約</a
            >および<a
              [href]="privacyUrl"
              target="_blank"
              class="text-link primary--text"
              >プライバシーポリシー</a
            >に同意します。
          </span>
        </label>

        <div class="text-center mb-6">
          <button
            type="button"
            class="submit-button"
            medium=""
            (click)="register()"
          >
            <span class="v-btn__content text-button-medium"> 登録 </span>
          </button>
        </div>

        <div
          style="display: flex; justify-content: center; align-items: baseline"
        >
          <div class="text-center mb-6 v-text-caption">
            認証メールが届かない方
          </div>
          <a
            (click)="navigate('register-resend')"
            class="text-link v-text-caption"
          >
            メール再送信
          </a>
        </div>

        <div
          style="display: flex; justify-content: center; align-items: baseline"
        >
          <div class="text-center mb-6 v-text-caption">
            よくあるご質問はこちら
          </div>
          <a
            class="text-link v-text-caption"
            href="https://kafunsho-doctor.doctors-station.com/#faq"
            >こちら</a
          >
        </div>

        <div class="divider mb-3"></div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: baseline;
          "
        >
          <div class="text-center mb-6 v-text-caption">
            アカウントをお持ちの方
          </div>
          <button
            (click)="navigate('login')"
            class="btn-lighten-5 v-btn theme--dark"
          >
            <p class="v-text bold">ログイン</p>
          </button>
          <!-- <a (click)="navigate('login')" class="text-link"> ログイン </a> -->
        </div>
      </div>
    </div>
  </div>
</div>
